import { SelectionModel } from '@angular/cdk/collections';
import { CdkDragStart, CdkDropList, moveItemInArray } from '@angular/cdk/drag-drop';
import { CdkVirtualScrollViewport } from "@angular/cdk/scrolling";
import { DatePipe } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, Inject, OnInit, ViewChild, ViewChildren, ViewRef } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { Router } from '@angular/router';
import moment from 'moment';
import { BehaviorSubject, ReplaySubject } from 'rxjs';
import { TokenStorage } from '../../../../../../core/auth/_services/token-storage.service';
import { LayoutUtilsService } from '../../../../../../core/_base/crud';
import { FunctionPublic } from '../../../dung-chung/__function/common_function';
import { CommonConFig } from '../../../dung-chung/__model/common_config.model';
import { DungChungService } from '../../../dung-chung/__services/dung-chung.service';
import { YeuCauDuyetGiaEditComponent } from '../../yeu-cau-duyet-gia/yeu-cau-duyet-gia-edit/yeu-cau-duyet-gia-edit.component';
import { DanhSachYCDG } from '../../yeu-cau-duyet-gia/yeu-cau-duyet-gia-model/yeu-cau-duyet-gia.model';
import { YeuCauBaoGia, YeuCauBaoGiaConfig, YeuCauBaoGiaCt } from '../kd-yeu-cau-bao-gia-dialog-model/kd-yeu-cau-bao-gia-dialog.model';
import { YeuCauBaoGiaService } from '../kd-yeu-cau-bao-gia-dialog-service/kd-yeu-cau-bao-gia-dialog.service';

@Component({
	selector: 'm-kd-yeu-cau-bao-gia-dialog-detail',
	templateUrl: './kd-yeu-cau-bao-gia-dialog-detail.component.html',
	styleUrls: ['../kd-yeu-cau-bao-gia-dialog.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	providers: [DatePipe]
})

export class YeuCauBaoGiaDetailComponent implements OnInit {

	@ViewChild(CdkVirtualScrollViewport, { static: false }) cdkVirtualScrollViewPort: CdkVirtualScrollViewport;
	@ViewChild('fileUploadImport', { static: false }) fileUploadImport: ElementRef;
	@ViewChildren('focusDetail') focusDetail;

	/*----------------------------Config Form ---------------------------*/
	CONFIG: CommonConFig;
	/* ------------------------------------------------------------------*/

	/*--------------------Comment columns mat-table----------------------*/
	displayedColumns = [];
	availableColumns = [
		{
			stt: 1,
			name: '#',
			displayName: '#',
			alwaysChecked: false,
			isShow: true
		},
		{
			stt: 2,
			name: 'MaHH',
			displayName: 'Mã hàng',
			alwaysChecked: false,
			isShow: true
		},
		{
			stt: 3,
			name: 'TenHH',
			displayName: 'Tên hàng',
			alwaysChecked: false,
			isShow: true
		},
		{
			stt: 4,
			name: 'SoLuong',
			displayName: 'Số lượng',
			alwaysChecked: false,
			isShow: true
		},
		{
			stt: 5,
			name: 'DonViTinh',
			displayName: 'ĐVT',
			alwaysChecked: false,
			isShow: true
		},
		{
			stt: 6,
			name: 'GiaGanNhat',
			displayName: 'Giá gần nhất',
			alwaysChecked: false,
			isShow: true
		},
		{
			stt: 7,
			name: 'GiaKhachHangMongMuon',
			displayName: 'Giá khách hàng mong muốn',
			alwaysChecked: false,
			isShow: true
		},
		{
			stt: 7,
			name: 'GiaMin',
			displayName: 'Giá min',
			alwaysChecked: false,
			isShow: true
		},
		{
			stt: 8,
			name: 'ThoiGianGiuGia',
			displayName: 'Thời hạn giữ giá',
			alwaysChecked: false,
			isShow: true
		},
		{
			stt: 9,
			name: 'GhiChu',
			displayName: 'Ghi chú',
			alwaysChecked: false,
			isShow: true
		},
		{
			stt: 10,
			name: 'TrangThai',
			displayName: 'Trạng thái',
			alwaysChecked: false,
			isShow: true
		},
	];
	/* ------------------------------------------------------------------*/


	/*--------------------Mat select search cho hàng hóa-----------------*/
	listId_HH: any[] = [];
	selectId_HH: string = '';
	filteredId_HH: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
	Id_HHFilterCtrl: string = '';
	haveElementId_HH: boolean = false;
	sumRecord = 0;
	/* ------------------------------------------------------------------*/


	/*------------------------ Danh sách trạng thái ----------------------*/
	listState: any[] = [];
	nameState: string = '';
	/* ------------------------------------------------------------------ */


	/*------------------------ Danh sách khách hàng-----------------------*/
	listKH: any[] = [];
	selectListKH: string = '';
	filteredListKH: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
	ListKHFilterCtrl: string = '';
	haveElementListKH: boolean = false;
	/* ------------------------------------------------------------------ */

	/*------------------------ Danh sách ĐVT -----------------------------*/
	listDVT: any[] = [];
	selectListDVT: string = '';
	filteredListDVT: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
	ListDVTFilterCtrl: string = '';
	haveElementListDVT: boolean = false;
	/* ------------------------------------------------------------------ */


	/* ------------------------------Selection ---------------------------*/
	selectedColumns = new SelectionModel<any>(true, this.availableColumns);
	selection = new SelectionModel<YeuCauBaoGiaCt>(true, []);
	/* ------------------------------------------------------------------ */


	/* --------------------------- Loading.... ---------------------------*/
	loadingSubject = new BehaviorSubject<boolean>(false);
	loading$ = this.loadingSubject.asObservable();
	/* ------------------------------------------------------------------ */


	/* ------------------- Các form trên dialog --------------------------*/
	MasterForm: FormGroup;
	HHForm: FormGroup;
	/* ------------------------------------------------------------------ */


	/*---------------------- Thông tin thao tác cho phiếu --------------- */
	item: YeuCauBaoGia;
	listChiTiet: YeuCauBaoGiaCt[] = [];
	tmpChiTiet: YeuCauBaoGiaCt[] = [];
	flagArray: any[] = [];
	/* ------------------------------------------------------------------ */


	/*------------------------- Extend field: ----------------------------*/
	title: string = '';					// Tiêu đề dialog
	previousIndex: number; 				// Lưu lại vị trí trước đó khi swap các cột trên lưới
	fixedPoint = 2;                		// Số chữ số phần thập phân cho kiểu dữ liệu số.
	isChange: boolean = false;			// Trường kiểm tra dialog có cập nhập - thay đổi dữ liệu hay không
	saveAdded: number[] = []		    // Save ID các record đã thay đổi để đánh dấu highlight trên list khi đóng dialog
	saveAddedCT: number[] = []
	viewLoading: boolean = false;   	// Loading khi mở dialog
	disableNewButton: boolean = true;	// Tắt nút thêm mới hàng khi chưa nhập đủ
	processImport: boolean = false;		// Có đang chạy import
	openTimKiemNangCao = false;
	textQuiDoiDVT = '';
	showButtonDG: boolean = false;

	/* ------------------------------------------------------------------ */

	constructor(
		public dialogRef: MatDialogRef<YeuCauBaoGiaDetailComponent>,
		@Inject(MAT_DIALOG_DATA) public data: any,
		private services: YeuCauBaoGiaService,
		private dungChungService: DungChungService,
		private MasterFB: FormBuilder,
		private HHFB: FormBuilder,
		private router: Router,
		public dialog: MatDialog,
		private tokenStorage: TokenStorage,
		private changeDetect: ChangeDetectorRef,
		private layoutUtilsService: LayoutUtilsService,
	) {
		this.dialogRef.disableClose = true;
	}

	/*---------------------------- LOAD DATA --------------------------------*/
	ngOnInit() {

		/*Load all dropdown and create form */
		this.ListKH();
		this.ListState();

		/*Load cấu hình config form */
		this.CONFIG = new CommonConFig();
		this.item = this.data.data;
		this.title = this.getTitle();

		this.createForm();

		/*Handel keydown event in dialog*/
		this.dialogRef.keydownEvents().subscribe(event => {
			if (event.key == "Escape" && !this.openTimKiemNangCao) {
				this.back();
			}
			this.changeDetectView();
		});

		/*Show column */
		this.showColumnsInTable();
		this.applySelectedColumns();
	}
	/* -----------------------------------------------------------------------*/


	/*----------------- Create Form with appropriate sub forms ---------------*/
	createForm() {
		/*Get name of người lập phiếu */
		var tenNguoiLap = '';
		this.tokenStorage.getFullName().subscribe(t => { tenNguoiLap = t; });

		var idUser = '';
		this.tokenStorage.getIDUser().subscribe(t => { idUser = t; });
		this.item.NguoiTao = +idUser;

		/*Group các Form */
		this.MasterForm = this.MasterFB.group({
			SoPhieu: [this.item.SoPhieu],
			NgayLapPhieu: [this.item.NgayTao],
			TenNguoiLap: [this.item.TenNguoiTao],
			TrangThai: [this.nameState],
			MaKH: [this.item.IdKh.toString()],
			TenKH: [this.item.TenKH],
			NgayYeuCauBg: [this.item.NgayYeuCauBg],
		});

		if (!(this.item.MaKH == undefined || this.item.MaKH == '')) {
			this.selectListKH = this.item.IdKh.toString()
		}

		/*Disable các trường dữ liệu không thay đổi */
		this.MasterForm.disable();

		/*------------------------------------------------------------------*/

		/*Add dữ liệu chi tiết*/
		if (this.item.listYeuCauBaoGiaCt.length > 0) {
			this.listChiTiet = this.item.listYeuCauBaoGiaCt;
			this.tmpChiTiet = [];
			this.showButtonDG = false;
			for (let i = 0; i < this.listChiTiet.length; i++) {
				let tmpElement = new YeuCauBaoGiaCt();
				tmpElement.copy(this.listChiTiet[i])
				this.tmpChiTiet.push(tmpElement);

				if (this.item.listYeuCauBaoGiaCt[i].LapYeuCauDuyetGia == 0  && this.item.listYeuCauBaoGiaCt[i].TrangThai == 'PBG_DETAIL_DADUYETBAOGIA')
				{
					let endDate = new Date(new Date(this.item.listYeuCauBaoGiaCt[i].ThoiGianDuyet).getTime() + this.item.listYeuCauBaoGiaCt[i].ThoiHanGiuGia * 24 * 60 * 60 * 1000);
					if(new Date() < endDate){
						this.showButtonDG = true;
					}
				}
			}
			if(this.data.data.isShowFromDuyetGia != undefined){
				this.showButtonDG = false;
			}
			this.tmpChiTiet = [...this.tmpChiTiet];
		}
		this.changeDetectView();
	}
	getTitle(): string {
		return 'Chi tiết yêu cầu báo giá';
	}
	getTrangThaiDetail(state: string) {
		let item = YeuCauBaoGiaCt.optionTrangThaiDetail.find(x => x.value == state)
		if (item != null) {
			return item.name;
		}
		return '';
	}
	/* -----------------------------------------------------------------------*/


	/*--------- Các hàm hỗ trợ hiển thị các cột và chuyển cột trong bảng------*/
	showColumnsInTable() {
		for (let i = 0; i < this.availableColumns.length; i++) {
			if (this.availableColumns[i].isShow == false) {
				this.selectedColumns.toggle(this.availableColumns[i]);
			}
		}
	}
	findIndexColumn(column: string) {
		for (let i = 0; i < this.availableColumns.length; i++) {
			if (this.availableColumns[i].name == column)
				return i;
		}
	}
	dragStarted(event: CdkDragStart, column: string) {
		this.previousIndex = this.findIndexColumn(column);
	}
	dropListDropped(event: CdkDropList, column: string) {
		if (event) {
			moveItemInArray(this.availableColumns, this.previousIndex, this.findIndexColumn(column));
			this.applySelectedColumns();
		}
	}
	applySelectedColumns() {
		if (this.item.TinhTrang == YeuCauBaoGia.optionsTinhTrang[4].value) {
			this.availableColumns.push({
				stt: 10,
				name: 'actions',
				displayName: 'Thao tác',
				alwaysChecked: false,
				isShow: true
			})
		}
		this.selectedColumns = new SelectionModel<any>(true, this.availableColumns);
		let _selectedColumns = this.selectedColumns.selected;
		for (let i = 0; i < this.availableColumns.length; i++) {
			this.selectedColumns.toggle(this.availableColumns[i]);
			for (let j = 0; j < _selectedColumns.length; j++) {
				if (this.availableColumns[i].name == _selectedColumns[j].name) {
					this.selectedColumns.toggle(this.availableColumns[i]);
					break;
				}
			}
		}
		const _applySelectedColumns: string[] = [];
		this.selectedColumns.selected.forEach(col => { _applySelectedColumns.push(col.name) });
		this.displayedColumns = _applySelectedColumns;
	}
	/* -----------------------------------------------------------------------*/


	/*------------------------- Hàm lấy danh sách-----------------------------*/
	ListState() {
		this.dungChungService.listState(YeuCauBaoGia.category_path).subscribe(res => {
			this.loadingSubject.next(false);
			if (res && res.status === 1) {
				this.listState = res.data;
				this.checkState();
				this.changeDetectView();
			};
		});
	}
	checkState() {
		this.listState.forEach(element => {
			if (element.Code == this.item.TinhTrang) {
				this.nameState = element.Description;
				if (this.MasterForm != null)
					this.MasterForm.controls["TrangThai"].setValue(this.nameState);
			}
		});
	}

	ListId_HH() {
		this.dungChungService.layDanhSachHangHoaTheoLoai(YeuCauBaoGia.thanhPhamId).subscribe(res => {
			this.loadingSubject.next(false);
			if (res && res.status === 1) {
				this.listId_HH = res.data;
				this.sumRecord = this.listId_HH.length;
				this.filteredId_HH.next(this.listId_HH.slice());
				this.changeDetectView();
			};
		});
	}
	filterId_HH(searchTmp: string = '') {
		if (!this.listId_HH) {
			return;
		}
		// get the search keyword
		let search = this.Id_HHFilterCtrl;
		if (searchTmp != '' && searchTmp != null)
			search = '' + searchTmp;

		if (!search) {
			this.sumRecord = this.listId_HH.length;
			this.filteredId_HH.next(this.listId_HH.slice());
			return;
		} else {
			search = search.toLowerCase();
		}

		if (searchTmp != '') {
			this.sumRecord = this.listId_HH.filter(ts => ts.Ma_Ten_HH.toLowerCase().indexOf(search) > -1).length;
			this.filteredId_HH.next(
				this.listId_HH.filter(ts =>
					ts.Ma_Ten_HH.toLowerCase().indexOf(search) > -1)
			);
		}
		else {
			this.sumRecord = this.listId_HH.filter(ts => ts.Ma_Ten_HH.toLowerCase().indexOf(search) > -1).length;
			this.filteredId_HH.next(
				this.listId_HH.filter(ts =>
					ts.Ma_Ten_HH.toLowerCase().indexOf(search) > -1)
			);
		}

		this.changeDetectView();
	}

	ListKH() {
		this.dungChungService.listKH().subscribe(res => {
			this.loadingSubject.next(false);
			if (res && res.status === 1) {
				this.listKH = res.data;
				this.filteredListKH.next(this.listKH.slice());
				this.changeDetectView();
			};
		});
	}
	filterListKH() {
		if (!this.listKH) {
			return;
		}
		let search = this.ListKHFilterCtrl;
		if (!search) {
			this.filteredListKH.next(this.listKH.slice());
			return;
		} else {
			search = search.toLowerCase();
		}
		this.filteredListKH.next(
			this.listKH.filter(ts =>
				(ts.MaKH + ' - ' + ts.TenKH).toLowerCase().indexOf(search) > -1)
		);
		this.changeDetectView()
	}
	getNameKH() {
		let name = '';
		if (this.listKH.length > 0) {
			var item = this.listKH.filter(x => x.Id_KH == +this.MasterForm.controls['MaKH'].value);
			if (item.length > 0) name = item[0].MaKH;
		}
		return name ? name : '';
	}

	ListDVT() {
		this.dungChungService.getDSDonViTinh().subscribe(res => {
			this.loadingSubject.next(false);
			if (res && res.status === 1) {
				this.listDVT = res.data;
				this.filteredListDVT.next(this.listDVT.slice());
				this.changeDetectView()
			};
		});
	}
	changeDVT() {
		if (!this.HHForm.controls["SanPhamMoi"].value) {
			this.listId_HH.forEach(element => {
				if (element.IdHH == +this.selectId_HH) {
					var listDVTHH = []
					listDVTHH.push(element.DVT);
					if (element.Dvt2 != null && element.Dvt2 > 0)
						listDVTHH.push(element.Dvt2);
					if (element.Dvt3 != null && element.Dvt3 > 0)
						listDVTHH.push(element.Dvt3);

					let currentDVT = listDVTHH.findIndex(x => x == +this.HHForm.controls["DVT"].value)
					if (currentDVT == 1) {
						var numQuiDoi = Number(this.f_number(this.HHForm.controls["SoLuong"].value))
							* Number(element.QuiDoiDVT2)
						if (numQuiDoi > 0)
							this.textQuiDoiDVT = this.f_number(numQuiDoi) + ' ' + element.TenDVT
					}
					else if (currentDVT == 2) {
						var numQuiDoi = Number(this.f_number(this.HHForm.controls["SoLuong"].value))
							* Number(element.QuiDoiDVT3)
						if (numQuiDoi > 0)
							this.textQuiDoiDVT = this.f_number(numQuiDoi) + ' ' + element.TenDVT
					}
					else if (currentDVT == 0) {
						this.textQuiDoiDVT = '';
					}
				}
			});
		}
	}
	/* -----------------------------------------------------------------------*/


	/*------------------ Hàm hỗ trợ format các dạng số trên form -------------*/
	showErrorInputSL(columnName: string, formGroup: any, name: string) {
		let message = "";
		let controls = formGroup.controls;
		if (controls[columnName].value.length == 0 || this.formatComparenumber(controls[columnName].value) == 0) return name + ' là bắt buộc';
		if (controls[columnName].hasError('maxlength')
			|| (controls[columnName].value.length > 22
				&& (controls[columnName].value.indexOf(',') == 0 || controls[columnName].value.indexOf(',') > 21)))
			return 'Tối đa 18 chữ số với 2 chữ số thập phân';
		return message;
	}
	ValidateChangeNumberForm(event: any, isEvent: boolean = true) {
		var count = 0;
		if (isEvent) {
			for (let i = 0; i < event.target.value.length; i++) {
				if (event.target.value[i] == ',') {
					count += 1;
				}
			}
		}
		else {
			event = "" + event
			for (let i = 0; i < event.length; i++) {
				if (event[i] == ',') {
					count += 1;
				}
			}
		}
		var regex = this.CONFIG.REGEX_SPECIAL_CHARACTER;
		var found = isEvent ? event.target.value.match(regex) : event.match(regex);
		if (found != null) {
			const message = 'Số lượng không gồm chữ hoặc kí tự đặc biệt';
			this.layoutUtilsService.showErorr(message);
			return false;;
		}
		if (count >= 2) {
			const message = 'Số lượng không thể có nhiều hơn 2 dấu .';
			this.layoutUtilsService.showErorr(message);
			return false;;
		}
		return true;
	}
	formatNumber(item: string) {
		if (item == '' || item == null || item == undefined) return '';
		if (typeof (item) === "string") {
			item = item.replace(/,/g, "");
		}
		return Number(Math.round(parseFloat(item + 'e' + this.fixedPoint)) + 'e-' + this.fixedPoint).toFixed(this.fixedPoint)
	}
	formatComparenumber(number: string) {
		return +number.replace(/\./g, "").replace(/,/g, ".");;
	}
	f_currency(value: string): any {
		if (value == null || value == undefined || value == '') value = '0.00';
		let nbr = Number((value.substring(0, value.length - (this.fixedPoint + 1)) + '').replace(/,/g, ""));
		return (nbr + '').replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,") + value.substr(value.length - (this.fixedPoint + 1), (this.fixedPoint + 1));
	}
	f_currency_V2(value: string): any {
		if (value == null || value == undefined || value == '') return '';
		let nbr = Number((value + '').replace(/,/g, ""));
		return (nbr + '').replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
	}
	f_currency_VND(value: string): any {
		if (value == null || value == undefined) return YeuCauBaoGiaCt.DEFAULT_NUMBER_VALUE;
		return new Intl.NumberFormat('de-DE', { style: 'decimal', currency: 'VND', minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(Number(value));
	}
	f_number(item: any = "0.00") {
		return FunctionPublic.F_NUMBER(item);
	}
	getThoiGianGiuGia(item:any){
		if(item.ThoiGianDuyet == null){
			return ''
		}
		let endDate = new Date(new Date(item.ThoiGianDuyet).getTime() + item.ThoiHanGiuGia * 24 * 60 * 60 * 1000)
		return 'Từ ' + this.getFormatDate(item.ThoiGianDuyet) + ' - Đến ' + this.getFormatDate(endDate.toISOString());
	}
	checkThoiGianGiuGia(item:any){
		if(item.ThoiGianDuyet == null){
			return false;
		}
		if(this.data.data.isShowFromDuyetGia != undefined){
			return false;
		}
		let endDate = new Date(new Date(item.ThoiGianDuyet).getTime() + item.ThoiHanGiuGia * 24 * 60 * 60 * 1000);
		return new Date() <= endDate;
	}
	keyUpInputNumberVND(event) {
		FunctionPublic.preventAlphaV2(event);
	}
	changeInputNumberVND(event, columnName, min: number = 0, formGroup) {
		let controls = formGroup.controls;
		let position = event.target.selectionStart;
		let sizeStart = event.target.value.toString().length;
		let sizeEnd = sizeStart;
		var regex = /[a-zA-ZÀÁÂÃÈÉÊÌÍÒÓÔÕÙÚĂĐĨŨƠàáâãèéêìíòóôõùúăđĩũơƯĂẠẢẤẦẨẪẬẮẰẲẴẶẸẺẼỀỀỂưăạảấầẩẫậắằẳẵặẹẻẽềềểỄỆỈỊỌỎỐỒỔỖỘỚỜỞỠỢỤỦỨỪễệỉịọỏốồổỗộớờởỡợụủứừỬỮỰỲỴÝỶỸửữựỳỵỷỹ]/g;
		var found = event.target.value.match(regex);
		if (found != null) {
			event.preventDefault();
		}
		else {
			if (event.keyCode === 46 || event.keyCode === 37 || event.keyCode === 39 || event.keyCode === 8 || event.keyCode === 9) { return; }

			let data = FunctionPublic.slListChangedV2(event);
			if (data) {
				if (this.f_number(data) < min && event.data && event.data == '0') data = this.f_number((min));
				controls[columnName].setValue(data);
				sizeEnd = data.toString().length;
				let balance = sizeEnd - sizeStart;
				event.target.selectionStart = position + balance;
				event.target.selectionEnd = position + balance;

				if (data.length == 4) {
					event.target.selectionStart = position;
					event.target.selectionEnd = position;
				}

			} else {
				controls[columnName].setValue(this.f_number((min)));
			}
		}
	}
	changeInputOfFormVND(controlName: string, event: any, min: number = 0, formGroup) {
		let controls = formGroup.controls;
		if (this.ValidateChangeNumberForm(event)) {
			let tmpValue = controls[controlName].value.replace(/\./g, "").replace(/,/g, ".");

			if (Number(tmpValue) < min) tmpValue = min;

			if (!controls[controlName].invalid) {
				controls[controlName].setValue(
					this.f_number((tmpValue))
				);
			}
			if (tmpValue.indexOf(',') == 0 && tmpValue.length == 1) {
				tmpValue = min;
			}
			controls[controlName].setValue(
				this.f_number((tmpValue))
			);
		}
		else {
			controls[controlName].setValue(this.f_number((min)));
		}
	}
	changeInputNumberVNDInList(event: any, min: number = 0) {

		let position = event.target.selectionStart;
		let sizeStart = event.target.value.toString().length;
		let sizeEnd = sizeStart;
		var regex = /[a-zA-ZÀÁÂÃÈÉÊÌÍÒÓÔÕÙÚĂĐĨŨƠàáâãèéêìíòóôõùúăđĩũơƯĂẠẢẤẦẨẪẬẮẰẲẴẶẸẺẼỀỀỂưăạảấầẩẫậắằẳẵặẹẻẽềềểỄỆỈỊỌỎỐỒỔỖỘỚỜỞỠỢỤỦỨỪễệỉịọỏốồổỗộớờởỡợụủứừỬỮỰỲỴÝỶỸửữựỳỵỷỹ]/g;
		var found = event.target.value.match(regex);
		if (found != null) {
			event.preventDefault();
		}
		else {
			if (event.keyCode === 46 || event.keyCode === 37 || event.keyCode === 39 || event.keyCode === 8 || event.keyCode === 9) { return; }

			let data = FunctionPublic.slListChangedV2(event);
			console.log(data)
			if (data) {
				if (this.f_number(data) < min && event.data && event.data == '0') data = this.f_number(min);
				event.target.value = data;
				sizeEnd = data.toString().length;
				let balance = sizeEnd - sizeStart;
				event.target.selectionStart = position + balance;
				event.target.selectionEnd = position + balance;
				if (data.length == 4) {
					event.target.selectionStart = position;
					event.target.selectionEnd = position;
				}
			} else {
				event.target.value = this.f_number((min));
			}
		}
	}
	changeInputOfFormVNDInList(columnName: string, event: any, min: number = 0, item: YeuCauBaoGiaCt) {

		if (this.ValidateChangeNumberForm(event)) {
			let tmpValue = this.f_number(event.target.value.toString());

			if (Number(tmpValue) < min) tmpValue = min;

			if (!item[columnName]) {
				item[columnName] = tmpValue.toString();
			}

			if (tmpValue.toString().indexOf(',') == 0 && tmpValue.toString().length == 1) {
				tmpValue = min;
			}
			item[columnName] = tmpValue.toString();
		}
		else {
			item[columnName] = min.toString();
		}

		this.changeDetectView();
	}
	/* -----------------------------------------------------------------------*/


	/*----------------- Hàm hỗ trợ format các dạng ngày trên form ------------*/
	getFormatDate(v: string = '') {
		if (v != null && v != undefined && v != '') {
			return v.includes('T') ? v.replace(/(\d{4})(-)(\d{2})(-)(\d{2})(T)(\d{2})(:)(\d{2})(:)(\d{2}).*$/g, "$5/$3/$1") : v.replace(/(\d{4})(-)(\d{2})(-)(\d{2})/g, "$5/$3/$1");
		}
		return '';
	}
	f_convertDate(p_Val: any) {
		if (p_Val == null || p_Val == undefined || p_Val == '') return '';
		let a = p_Val === "" ? new Date() : new Date(p_Val);
		return ("0" + (a.getDate())).slice(-2) + "/" + ("0" + (a.getMonth() + 1)).slice(-2) + "/" + a.getFullYear();
	}
	/* -----------------------------------------------------------------------*/


	/*---------------------------- Thao tác trên form ------------------------*/
	back() {
		this.dialogRef.close(
			{
				isChange: this.isChange,
				dataAdd: this.saveAdded,
			}
		);
	}
	getSLTonKho(item: YeuCauBaoGiaCt) {
		return (
			`SL có PO: ${this.f_number(item.SLCoPO == null ? 0 : item.SLCoPO)} \n` +
			`SL tự do: ${this.f_number(item.SLTuDo == null ? 0 : item.SLTuDo)}`
		);
	}
	createYCDG(detailBG: YeuCauBaoGiaCt = null) {
		let _listDetail: DanhSachYCDG[] = [];
		if (detailBG != null) {
			let tmp = new DanhSachYCDG();
			tmp.clear();
			tmp.YCBGCT = detailBG.Id;
			tmp.IdHH = detailBG.HangHoaId;
			tmp.MaHH = detailBG.MaHH;
			tmp.TenHH = detailBG.TenHH;
			tmp.IdDVT = detailBG.Dvt;
			tmp.TenDVT = detailBG.DonViTinh;
			tmp.SoLuong = detailBG.SoLuong;
			tmp.YCBG = this.item.SoPhieu;
			tmp.IdKH = this.item.IdKh;
			tmp.MaKH = this.item.MaKH;
			tmp.TenKH = this.item.TenKH;
			tmp.Min = detailBG.GiaMin;
			tmp.Max = detailBG.GiaMax;
			tmp.KLSaiSo = detailBG.KLSaiSo;
			tmp.GiaKHDN = detailBG.GiaKhachHangMongMuon;
			tmp.GiaMoi = 0;
			tmp.ThoiHanGiuGia = detailBG.ThoiHanGiuGia;
			tmp.NgayYeuCauGH = moment(new Date()).format('YYYY-MM-DD[T]HH:mm:ss.SSS');
			_listDetail.push(tmp);
		}
		else
			this.item.listYeuCauBaoGiaCt.forEach(x => {
				let endDate = new Date(new Date(x.ThoiGianDuyet).getTime() + x.ThoiHanGiuGia * 24 * 60 * 60 * 1000);

				if(x.TrangThai == "PBG_DETAIL_DADUYETBAOGIA" && (new Date() < endDate)){
					let tmp = new DanhSachYCDG();
					tmp.clear();
					tmp.YCBGCT = x.Id;
					tmp.IdHH = x.HangHoaId;
					tmp.MaHH = x.MaHH;
					tmp.TenHH = x.TenHH;
					tmp.IdDVT = x.Dvt;
					tmp.TenDVT = x.DonViTinh;
					tmp.SoLuong = x.SoLuong;
					tmp.YCBG = this.item.SoPhieu;
					tmp.IdKH = this.item.IdKh;
					tmp.MaKH = this.item.MaKH;
					tmp.TenKH = this.item.TenKH;
					tmp.Min = x.GiaMin;
					tmp.Max = x.GiaMax;
					tmp.GiaKHDN = x.GiaKhachHangMongMuon;
					tmp.GiaMoi = 0;
					tmp.KLSaiSo = x.KLSaiSo;
					tmp.ThoiHanGiuGia = x.ThoiHanGiuGia;
					tmp.NgayYeuCauGH = moment(new Date()).format('YYYY-MM-DD[T]HH:mm:ss.SSS');
					_listDetail.push(tmp);
				}
			})
		if(_listDetail.length == 0){
			const message = 'Mặt hàng chưa duyệt báo giá hoặc hết hạn giữ giá';
			this.layoutUtilsService.showErorr(message);
			return;
		}
		const dialogRef = this.dialog.open(YeuCauDuyetGiaEditComponent, {
			data: {
				add: true,
				data: {
					IdDG: 0.
				},
				listDetail: _listDetail,
			},
			maxHeight: '90vh',
			width: '90vw'
		});
		dialogRef.afterClosed().subscribe(res => {
			if (res && res.isSuccess) {
				this.back();
				let businessType = this.router.url.split("/")[1] === YeuCauBaoGiaConfig.B2B.PARAM_REQUEST_PRICE
				? YeuCauBaoGiaConfig.B2B.BUSINESS_TYPE
				: YeuCauBaoGiaConfig.B2C.BUSINESS_TYPE;
				if(businessType == YeuCauBaoGiaConfig.B2B.BUSINESS_TYPE){
					this.router.navigate(['kd-yeu-cau-duyet-gia', {}], { state: { saveNewTTHV: res.dataAdd } });
				}
				else{
					this.router.navigate(['kd-yeu-cau-duyet-gia-b2c', {}], { state: { saveNewTTHV: res.dataAdd } });

				}
			}
		});
	}
	/* -----------------------------------------------------------------------*/


	/*------------------------------ Extend Options --------------------------*/
	changeDetectView() {
		if (!(this.changeDetect as ViewRef).destroyed) {
			this.changeDetect.detectChanges()
		}
	}
	/* -----------------------------------------------------------------------*/

}